import React, { useEffect } from "react";

import { HashRouter } from "react-router-dom";

import "./scss/style.scss";
import MainRoute from "./views/MainRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import addNotification from "react-push-notification";
import { io } from "socket.io-client";
import {
  createSocket,
  updateNotifyList,
} from "./views/chatManagement/_redux/chatActions";
import { updateChatHistory } from "./views/chatManagement/_redux/chatActions";

var socket = io(process.env.REACT_APP_SOCEKT_URL, {
  transports: ["websocket"],
});

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const App = () => {
  const dispatch = useDispatch();

  const onEvent = (message, type) => {
    addNotification({
      title: type,
      subtitle: "New Message is Arrived",
      message: message?.messageValue
        ? message.messageValue
        : message.metaData.notfyHead,
      // message: message?.messageValue?:message?.messageValue:message.metaData.notfyHead,
      theme: "darkblue",
      native: true, // when using native, your OS will handle theming.
    });
  };

  const { userId } = useSelector(
    (state) => ({
      userId: state?.auth?.user?.userId,
    }),
    shallowEqual
  );

  //joins in notification room
  // useEffect(() => {
  //   dispatch(createSocket(socket));
  //   if (userId) {
  //     socket.connect();
  //     socket.emit("join", { fromUser: userId, room: userId }, () => {});
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userId]);

  useEffect(() => {
    dispatch(createSocket(socket));
    if (userId) {
      socket.connect();
      socket.emit("create-room", userId);
      socket.emit("joinRoom", userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  // used to listen notification update
  useEffect(() => {
    socket.on("recieveNotification", (notificationRecieved) => {
      dispatch(updateNotifyList(notificationRecieved));
      onEvent(notificationRecieved, "New Chat Message");
    });

    socket?.on("messageService", (message) => {
      onEvent(message, "New Chat Message");
      dispatch(updateChatHistory(message));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HashRouter>
      <React.Suspense fallback={loading}>
        <ToastContainer />
        <MainRoute />
      </React.Suspense>
    </HashRouter>
  );
};

export default App;
